/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
    function toggleButtonState() {
        var checkbox = document.getElementById("slidecart-agree");
        var button = document.getElementById("checkoutButton");
        var button_text = document.getElementById("button_text");
        if (checkbox.checked) {
            button.classList.remove("non-clickable-button");
            button_text.innerText = "Jetzt sicher zur Kasse";
        } else {
            button.classList.add("non-clickable-button");
            button_text.innerText = "Bestätige das Widerrufsrecht";
        }
    }

function applyDiscount(salePrice, copPrice) {
    var storedDiscount = JSON.parse(localStorage.getItem("discountMetaobject"));
    if (!storedDiscount || isNaN(storedDiscount.value) || storedDiscount.value <= 0) return;

    var discount_code_name = storedDiscount.code, discount_percent = storedDiscount.value;
    var priceElement = document.querySelector(".product-meta__price-list-container.product-info .price-list"),
        priceContainer = document.querySelector(".product-meta__price-list-container.product-info"),
        discountLabel = document.querySelector(".product-info .savings");

    if (!priceElement || !priceContainer) return;

    let newPrice = (salePrice * (1 - discount_percent / 100)).toFixed(2),
        discount = (salePrice - newPrice).toFixed(2);

    priceElement.innerHTML = `
        <span class="price price--large">
            <span class="price price--large price--highlight cop-price">
                <span class="visually-hidden">Angebotspreis</span> ${newPrice}€
            </span>
            <span class="price price--compare price--large">
                <span class="visually-hidden">Regulärer Preis</span> <s>${copPrice}€</s>
            </span>
        </span>`;

    document.querySelector(".discount-item__discount-badge")?.remove();

    var discountBadge = document.createElement("span");
    discountBadge.className = "discount-item__discount-badge discount-badge";
    discountBadge.innerHTML = `
        <svg focusable="false" width="10" height="10" class="icon icon--discount-badge" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path>
        </svg> ${discount_code_name} (-${discount}€)`;

    priceContainer.parentNode.insertBefore(discountBadge, priceContainer);

    if (discountLabel) {
        let newLabelPrice = (parseFloat(discountLabel.innerText.replace(/[^\d,.-]/g, '')) || 0) + parseFloat(discount);
            newLabelPrice = newLabelPrice.toFixed(2);
        discountLabel.innerHTML = `<span>${newLabelPrice}€</span>`;
    }
}


document.addEventListener("DOMContentLoaded", function () {
 
    function applyDiscounts() {
        var storedDiscount = JSON.parse(localStorage.getItem("discountMetaobject"));
        if (!storedDiscount || isNaN(storedDiscount.value) || storedDiscount.value <= 0) return;

        var discount_code_name = storedDiscount.code,
            discount_percent = storedDiscount.value;

        document.querySelectorAll("product-item[data-discount]").forEach(product => {
            // Verhindere doppelte Rabattanwendung
            if (product.classList.contains("discount-applied")) return;

            var priceElement = product.querySelector(".product-item-meta__price-list-container"),
                labelContainer = product.querySelector(".product-item__label-list.label-list"),
                discountLabel = product.querySelector(".product-item__label-list.label-list .savings");

            if (!priceElement || !labelContainer) return;

            let originalPrice = parseFloat(product.getAttribute("data-variant-price")) / 100,
                compareAtPrice = parseFloat(product.getAttribute("data-variant-compare-at-price")) / 100 || originalPrice;

            if (isNaN(originalPrice) || originalPrice <= 0) return;

            let newPrice = (originalPrice * (1 - discount_percent / 100)).toFixed(2),
                discount = (originalPrice - newPrice).toFixed(2);

            // Aktualisiere Preis-Anzeige
            priceElement.innerHTML = `
            <div class="price-list price-list--centered tdf-cart-item-p-p">
                <span class="price price--highlight">
                    <span class="visually-hidden">Angebotspreis</span>${newPrice} €
                </span>
                <span class="price price--compare">
                    <span class="visually-hidden">Regulärer Preis</span>${compareAtPrice} €
                </span>
            </div>`;

            // Rabatt-Badge hinzufügen, falls nicht vorhanden
            if (!labelContainer.querySelector(".label.label--badge")) {
                let discountBadge = document.createElement("span");
                discountBadge.className = "label label--badge";
                discountBadge.innerHTML = `
                    <svg focusable="false" width="10" height="10" class="icon icon--discount-badge" viewBox="0 0 10 10">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path>
                    </svg>  ${discount_code_name}`;
                labelContainer.appendChild(discountBadge);
            }

            // Rabatt-Label aktualisieren
            if (discountLabel) {
                let labelPrice = parseFloat(discountLabel.innerText.replace(/[^\d,.-]/g, '')) || 0;
                let newLabelPrice = (labelPrice + parseFloat(discount)).toFixed(2);
                discountLabel.innerHTML = `<span>${newLabelPrice}€</span>`;
            }

            // Markiere Produkt als rabattiert
            product.classList.add("discount-applied");
        });
    }

    // Einmal für geladene Produkte ausführen
    applyDiscounts();

    // MutationObserver für nachgeladene Produkte
    const observer = new MutationObserver((mutations) => {
        let addedNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
        if (addedNodes) applyDiscounts();
    });

    // Beobachte relevante Abschnitte für nachgeladene Produkte
    let sectionsToWatch = [
        "recently-viewed-products",
        "featured-collections"
    ];

    document.querySelectorAll("[id*='__product-recommendations']").forEach(section => {
        sectionsToWatch.push(`#${section.id}`);
    });

    sectionsToWatch.forEach(selector => {
        let section = document.querySelector(selector);
        if (section) {
            observer.observe(section, { childList: true, subtree: true });
            console.log(`👀 Watching for dynamically loaded products in ${selector}...`);
        } else {
            console.log(`⚠ Section not found: ${selector}`);
        }
    });
});


